import styled from 'styled-components'

import { H3 } from 'js/components/Heading'
import HideVisually from 'js/components/HideVisually/HideVisually'

interface WidgetTitleProps {
    title?: string
    widgetTitle: string
    className?: string
    style?: React.CSSProperties
}

const StyledHeading = styled(H3)`
    color: inherit; // inherit readable color from row Section
`

const WidgetTitle = ({
    title,
    widgetTitle,
    className,
    style,
}: WidgetTitleProps) => {
    if (title) {
        return (
            <StyledHeading as="h2" className={className} style={style}>
                {title}
            </StyledHeading>
        )
    }

    return <HideVisually as="h2">{widgetTitle}</HideVisually>
}

export default WidgetTitle
